import cvvCard from '../../../assets/images/deposits/cvv-card.webp';
import { useTranslation } from 'react-i18next';
import { ScCvvMethodCard } from './styled';

export const CvvMethodCard = () => {
  const { t } = useTranslation('deposits');
  return (
    <ScCvvMethodCard>
      <span className="title">{t('cvvTitle')}</span>
      <div className="img-wrapper">
        <img className="img" src={cvvCard} alt="cvvCard" />
      </div>
    </ScCvvMethodCard>
  );
};
